<script setup>
import {Link} from '@inertiajs/vue3';
import axios from "axios";

const props = defineProps({
    id: Number,
    title: String,
    short_description: String,
    category_name: String,
    category_slug: String,
    first_name: String,
    last_name: String,
    created_at: String,
    slug: String,
    image: String,
    body: String,
    format: String,
    isActive: false,
    link_url: String
});

async function onShowDialog() {
    await axios.get(route('update.count'),{
        params: {
            id: props.id,
        },
    });
}
</script>
<template>
    <v-col cols="12" md="4" sm="6" lg="3">
        <v-dialog max-width="800" hight="100%" class="flex items-stretch"
                  @click="onShowDialog">
            <template v-slot:activator="{ props: activatorProps }">
                <v-card class="video-card" v-bind="activatorProps" flat>
                    <v-card tile class="h-100" variant="tonal">
                        <div class="card-img-cover w-100 h-100 position-relative position-relative">
                            <img :src="getImage(image)" class="card-img-top w-100 h-100" :alt="title">

                            <!-- <div class="d-flex align-items-center button-play-title w-100 position-absolute">
                                <img src="/assets/img/logo-youtube.png" style="color: black !important; width: 50px; height: 50px; object-fit: cover; margin-right: 10px;">
                                <h5 class="text-white bold mb-0" style="color: white !important;">{{ getTitle(title, 35) }}</h5>
                            </div> -->
                     
                            <div class="d-flex align-items-center justify-content-lg-start button-play-title w-100 position-absolute pl-2">
                                <img src="/assets/img/logo-youtube.png" style="left: 5px;color: #00000069 !important; width: 50px; height: 50px; object-fit: cover; margin-right: 10px;">
                                <h6 class="text-white bold mb-0" style="text-align: left; color: white !important;">{{ title }}</h6>
                            </div>
                        </div>
                    </v-card>

                </v-card>
            </template>
            <template v-slot:default="{ isActive }">
                <v-card class="dialog-card-news">
                    <iframe width="100%" height="500" class="dialog-card-news-iframe" :src="'https://www.youtube.com/embed/'+ link_url +'?si=beajwk0lgRip4bOO'"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                </v-card>
            </template>
        </v-dialog>
    </v-col>

</template>

<style scoped>

.button-play-title{
    text-align: left;
    bottom: 0px;
    height: 70px;
    left: 0px;
    background-color: #0a0a0a70;
}

.button-play-title {
    
    display: flex;
    align-items: center;
    width: 100%;
}

.play-button img {
    width: 60px;
    height: 60px;
    object-fit: cover;
}

.title-video {
    background-color: #d3d3d3; /* Example color for testing */
    padding: 10px;
    border-radius: 5px;
}

@media (max-width: 768px) {
    .video-card {
        /* height: 250px !important; */
    }
    /* .dialog-card-news {
        height: 250px !important;
    } */
    .dialog-card-news-iframe {
        /* height: 250px !important; */
    }
}
</style>
